import React from "react";
import { styled } from '@mui/material/styles';
import _ from "lodash";

import { BgImage } from "gbimage-bridge"
import { getImage } from "gatsby-plugin-image"

import { Link } from "gatsby"

import { getEntityUrl, getOverlayImages } from "../../util";
import Wrapper from "../../components/Wrapper";


import "core-js/proposals/string-match-all";
import OnlyMenuButtonTopBar from "../../components/TopBar/OnlyMenuButtonTopBar";
//polyfill for old Androids; TODO - move away from here

const Root = styled('div')(({ theme }) => ({

}));
Root.defaultProps = {
    "data-id": "Root"
  };
// ----------------------------------------------------------
const HomeContainer = styled('div')(({ theme }) => ({
    height: 'calc(100vh - 5px)',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    margin: '6px',
}));
HomeContainer.defaultProps = {
    "data-id": "HomeContainer"
  };
// ----------------------------------------------------------
const BackgroundImage = styled(BgImage)(({ theme }) => ({
    flexGrow: 2,
    backgroundSize: "cover",
    flexBasis:"40%",
    backgroundPosition:"left top!important"
}));
BackgroundImage.defaultProps = {
    "data-id": "Header"
  };
// ----------------------------------------------------------
const Title1 = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: 15,
    transform: 'translateY(-104%)',
    background: 'url(/images/logo-kinemathek.png) no-repeat',
    WebkitBackgroundSize: 'contain',
    backgroundSize: 'contain',
    height: 145,
    width: 110,
    color: 'transparent',

}));
// ----------------------------------------------------------
const Title2 = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 38,
    left: 14,
    height: 60,
    color: '#fff',
    fontFamily: 'frequenz',
    fontSize: 68,
    lineHeight: 1,
}));
// ----------------------------------------------------------
const ChildrenUl = styled('ul')(({ theme }) => ({
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    display: 'block',
    position:"relative"
}));
ChildrenUl.defaultProps = {
    "data-id": "ChildrenUl"
  };
// ----------------------------------------------------------
const ChildLi = styled('li')(({ theme }) => ({
    margin:"0",
    padding:"0"
}));
ChildLi.defaultProps = {
    "data-id": "ChildLi"
  };

const ChildLink = styled(Link)(({ theme }) => ({
    display: 'block',
    textDecoration: 'none',
    padding: '15px 10px',
    paddingLeft: '4px',
    background: '#FFF url(/images/smallarrow.png) no-repeat',
    backgroundPosition: '97% center',
    color: '#000',
    borderBottom: '1px solid #000',
    fontFamily: 'frequenz',
    fontSize: '1.5rem',
}));

const ChildDiv = styled('div')(({ theme }) => ({
}));

const EntityPage = (props) => {

    const { entity, pageContext, selectedModule, files } = props;
    const { strapiChildren: children } = entity;

    const image = getImage(entity.largeImage?.localFile);
    const { defaultLocale } = pageContext;

    return <Root className="kima-hp-list" >
        <Wrapper {...props} topbar={false} title={entity.title}>
            <HomeContainer  style={{ overflowX: 'hidden' }/*TODO - var*/}>
                <BackgroundImage image={image}  >

                    <Title2>{entity.shortDesc}</Title2>
                </BackgroundImage>
                <ChildrenUl>
                <Title1>{entity.title}</Title1>
                    {children.map((child, n) => {
                        const url = getEntityUrl({ entity: child, defaultLocale });

                        return (
                            <ChildLi>
                                <ChildLink to={url}>{child.title}</ChildLink>
                            </ChildLi>
                        );
                    })}
                </ChildrenUl>


            </HomeContainer>
        </Wrapper>
    </Root>
}

export default EntityPage;
